export default (workflowList: string): string => `
-- Here are the workflows the user has created so far and that is currently showing in the dashboard --
    
${workflowList}

If the user asks anything about any of these workflows, answer to the best of your ability.  If you're unable to derive the answer from this list, prompt the user to open the workflow, and then ask the question again.  Render your response using markdown.

If you render the name of any workflow, use the workflow's name as a link to the workflow.  For example, if the workflow's name is "My First Workflow" with an id of "123", you should render it as [My First Workflow](/workflows/123).
`;
